import { show, hide } from './../utility/transition'


const promisify = fn => (...args) => new Promise(resolve => fn(...args, resolve))
const promiseHide = promisify(hide)
const promiseShow = promisify(show)


function menuItem(listItem, link, dropdown) {

	let isOpen = false
	let onBeforeChange = isOpen => Promise.resolve()

	function open() {
		if (isOpen) return
		listItem.classList.add('open')
		const before = onBeforeChange(isOpen)
		isOpen = true
		return before.then(() => promiseShow(dropdown, 'show'))
	}

	function close() {
		if (!isOpen) return
		listItem.classList.remove('open')
		const before = onBeforeChange(isOpen)
		isOpen = false
		return before.then(() => promiseHide(dropdown, 'show'))
	}

	function toggle() {
		const action = isOpen ? close : open
		return action()
	}

	function setOnBeforeChange(fn) {
		onBeforeChange = () => {
			const before = fn(isOpen)
			if (before && before.then) return before
			return Promise.resolve()
		}
	}

	function setup() {
		if (!dropdown) return

		link.addEventListener('click', e => {
			event?.preventDefault()
			toggle()
		})

		window.addEventListener('keydown', event => {
			const escKey = (event.key === 'Escape' || event.keyCode === 27)
			if (isOpen && escKey) close()
		})
	}

	setup()

	return {
		open, close, isOpen: () => isOpen,
		onBeforeChange: setOnBeforeChange
	}
}


function menu(menuSelector, itemSelector, linkSelector, dropdownSelector) {

	const menuEl = document.querySelector(menuSelector)
	if (!menuEl) return
		
	const items = [...menuEl.querySelectorAll(itemSelector)]
	
	const menuItems = items.map(el => {
		const link = el.querySelector(linkSelector)
		const dropdown = el.querySelector(dropdownSelector)
		const m = menuItem(el, link, dropdown)
		m.onBeforeChange(() => closeAll(m))
		return m
	})

	function closeAll(current = null) {
		return Promise.all(
			menuItems
				.filter(item => item !== current && item.isOpen())
				.map(item => item.close())
		)
	}

	// let scrollClosed = false
	// window.addEventListener('scroll', () => {
	// 	if (window.scrollY < 200) {
	// 		scrollClosed = false
	// 	}
	// 	if (!scrollClosed && window.scrollY > 300) {
	// 		scrollClosed = true
	// 		closeAll()
	// 	}
	// })

	window.addEventListener('click', () => {
		closeAll()
	})

	menuEl.addEventListener('click', e => {
		e.stopPropagation()
	})
}

export default function init() {
    menu(
    	'.site-nav__inner',
    	'.site-nav__item', 
    	'.site-nav-link', 
    	'.site-nav-dropdown'
    )
}

console.log('nav.js loaded')